import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterContentChecked, AfterViewInit, ChangeDetectionStrategy, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of, BehaviorSubject, Observable, Subscription, Subject } from 'rxjs';
import { tap, mergeMap, finalize, map, first, delay } from 'rxjs/operators';
//import { PDFDocumentProxy } from 'pdfjs-dist';

import { AuthService } from '../../../../services/auth.service';
import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { DocumentManagementService, IUploadFile, IAzureBlobSasToken } from '../../../../common/services/document-management.service';
import { DialogService } from '../../../../common/services/dialog.service';
import { LayoutService } from '../../../../layouts/services/layout.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { ReportSelectorService } from '../../../../form-controls/services/report-selector.service';
import { SidePanelService } from '../../../../common/services/side-panel.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';

import { coReviewViewModel } from '../../../../models/comodel/coreviewviewmodel.model';
import { GenerateReportModel } from '../../../../reports/model/reports.model';
import { SidePanel } from '../../../../common/models/side-panel.model';
import { StateType } from '../../../../flow/models/flow.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { chiefsOrderReviewStatus, levelContext } from '../../../../models/comodel/chiefsorderdetailsmodel.model';
import { Note } from "../../../../common/models/note.model";
import { NoteType } from "../../../../common/models/note-type.enum";
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { Group } from '../../../models/group.model';
import { GroupService } from '../../../services/group.service';
import { UploadViewFilesComponent } from '../../../../common/components/fileUpload/upload-view-files.component';
import { ChiefsOrderMergeConstants } from '../../../../models/comodel/mergefieldsmodel.model';

@Component({
    selector: 'co-review-chiefsorder',
    templateUrl: './co-review-chiefsorder.component.html',
    styleUrls: ['./co-review-chiefsorder.component.scss'],
    standalone: false
})
export class CoReviewChiefsorderComponent implements OnInit,AfterContentInit, OnDestroy {

    @ViewChild("files") public _uploadViewFilesElement: UploadViewFilesComponent;
    @ViewChild("supplementalFiles") public _uploadViewSupplementalFilesElement: UploadViewFilesComponent;
    @ViewChild("downloadLink") public downloadLink: ElementRef;

    confirmTextEditDialog: Dialog = new Dialog("Any changes to the template must be documented in the notes of the Chief's Order. All the details will be reviewed by the Chief before signing.", [new DialogButton("OK", true, () => this.goEditLetter()), new DialogButton("Cancel", true, () => { })]);
    confirmFileDeleteDialog: Dialog = new Dialog("Are you sure you want to delete this file?", [new DialogButton("Delete the file", true, () => this.onFileDeleteConfirm()), new DialogButton("Cancel", true, () => { })]);
    confirmSubmittalDialog: Dialog = new Dialog("The Chief's Order was successfully submitted to the next level of review.", [new DialogButton("OK", true, () => this.onSubmittalDialogConfirm())]);
    confirmRejectionDialog: Dialog = new Dialog("The Chief's Order was rejected by the current review group.", [new DialogButton("OK", true, () => this.onRejectionDialogConfirm())]);
    selectAReviewGroupReminderDialog: Dialog = new Dialog("Please select a valid review group and try again.", [new DialogButton("OK", true, () => this.onSelectAReviewGroupReminderDialogConfirm())]);

    coInstanceId: string = '';
    coreReviewModel: coReviewViewModel;
    approveText: string = '';
    displayGroupAssignment: boolean = false;
    allGroups: Group[] = [];
    selectedGroup: Group = {
        id: "0",
        displayName: "---------- Please Select a Group ----------",
        active: true,
        groupType: "placeholder",
        permissions: [],
        users: []
    };


    get filesToShow(): IUploadFile[] {
        if (!this.coreReviewModel.files)
            this.coreReviewModel.files = [];

        return this.coreReviewModel.files;
    }

    get supplementalFilesToShow(): IUploadFile[] {
        if (!this.coreReviewModel.postIssueFiles)
            this.coreReviewModel.postIssueFiles = [];

        return this.coreReviewModel.postIssueFiles;
    }

    fileToDelete: IUploadFile;
    blobStr: any;
    pathStr: string;

    get title(): string {
        if (this.coreReviewModel) return this.coreReviewModel.templateName;
        return "";
    }
    currentPage: number = 1;
    pdfAvailable: boolean = false;
    pdfData: any;
    pdfUrl: string;
    subscription = new Subscription();
    form: FormGroup = new FormGroup({
        updatedContents: new FormControl('')
    });
    showRejectButton: boolean = false;
    notesText: string = '';
    isInternalVal: boolean = false;
    saveBlob: any;
    public activeSidePanel: SidePanel;
    private reportModel: GenerateReportModel = {
        useBanner: true,
        usePageNumberHeader: true,
        formatAsLetter: true,
        headerOnFirstPage: false,
        htmlHeader: "",
        html: "",
        htmlFooter: "",
        styleMergeFields: true
    } as GenerateReportModel;
    showError: boolean = false;
    totalPages: number = 0;
    private _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    get isLoading$(): Observable<boolean> {
        return this._isLoading$.asObservable();
    }

    subHeader: SubHeader = new SubHeader({ title: this.title, buttons: [{ name: "View Notes & Timeline", method: () => this.showNotesAndTimeline() }] });

    public sidePanelWithoutFieldNotes: SidePanel = new SidePanel({
        tabs: [{ title: "Review Notes", stateTypeRequired: StateType.ReviewForm }, { title: "Timeline", stateTypeRequired: StateType.ReviewForm }],
        sections: [{ componentName: 'ReviewNotesCommon', componentData: null, method: (event) => this.noteReplied(event) }, { componentName: 'Timeline', componentData: null }]
    });
    currentView: string;

    constructor(
        private activeRoute: ActivatedRoute,
        public _authService: AuthService,
        private chiefsOrderService: ChiefsOrderService,
        public dialogService: DynamicDialogService,
        private docMgmtSrvc: DocumentManagementService,
        public layoutService: LayoutService,
        private readonly loader: LoaderService,
        public reportService: ReportSelectorService,
        private location: Location,
        private router: Router,
        public sidePanelService: SidePanelService,
        private subHeaderService: SubHeaderService,
        public groupService: GroupService
    ) { }

    ngAfterContentInit() {       
    }
    ngOnInit() {
        this.coreReviewModel = new coReviewViewModel();
        this.coreReviewModel.currentLevel = { returnToGroup: '', returnToGroupId: '', mode: '' };
        this.coreReviewModel.reviews.push({ reviewStatus: chiefsOrderReviewStatus.Pending, letter: { htmlContent: '', id: '' }})
        this.loader.toggleLoader(true);
        this.coInstanceId = this.activeRoute.snapshot.params["coinstanceid"];
        this.currentView = this.router.url.split('/')[3].split('co-')[1];
        this.loadData(this.coInstanceId);
        this.setSubheader();
        this.layoutService.update('ChiefsOrders');
        this.activeSidePanel = this.sidePanelWithoutFieldNotes;
        this.sidePanelService.newSidePanel(this.activeSidePanel);
    }

    ngOnDestroy(): void {
        if (this.subscription)
            this.subscription.unsubscribe();
    }

    setSubheader(): void {
        this.subHeaderService.updateSubHeader(this.subHeader);
    }

    showNotesAndTimeline(): void {
        this.sidePanelService.toggleSidePanel(true);
    }

    loadData(instance: string): void {

        const pdf$ = this.chiefsOrderService.getchiefsorderinreview(instance).pipe(
            tap((contents) => {
                this.coreReviewModel = contents;
                //display the group selection if either the current level allows it, or the previous level did, for returns
                this.displayGroupAssignment = this.coreReviewModel.nextLevelOfReviewRequiresGroupSelection || this.coreReviewModel.priorLevel.canSelectAssignToGroup;
                this.reportModel.usePageNumberHeader = this.coreReviewModel.currentReview.letter.usePageNumberHeader;
                this.reportModel.mergeFields = this.coreReviewModel.mergeFields;
                this.reportModel.htmlHeader = this.coreReviewModel.currentReview.letter.htmlHeader;
                this.reportModel.html = this.coreReviewModel.currentReview.letter.htmlContent;
                this.reportModel.htmlFooter = this.coreReviewModel.currentReview.letter.htmlFooter;
                this.sidePanelService.updateSectionData("ReviewNotesCommon", this.coreReviewModel.notes);
                this.sidePanelService.updateSectionData("Timeline", this.coreReviewModel.timeline);
                this.setSubheader();
            }),
            mergeMap(() => {
                //If we need to display groups for selecting next level, fetch them
                if (this.displayGroupAssignment) {
                    return (this.groupService.get({ stubs: false }) as Observable<Group[]>).pipe(
                        tap((groups) => {
                            if (groups) {
                                groups.unshift(this.selectedGroup);
                                this.allGroups = groups;
                            }
                        })
                    );
                } else {
                    return of(null);
                }
            }),
            mergeMap(() => {
                if (this.reportModel.html && this.reportModel.html !== "") {
                    return this.chiefsOrderService.generateChiefsOrderDocument(this.reportModel).pipe(
                        tap((blob) => {
                            if (blob) {
                                this.pdfUrl = window.URL.createObjectURL(blob);
                                this.pdfData = blob;
                            }
                        })
                    );
                } else {
                    return of(null);
                }
            }),
            finalize(() => { this.subscription.add(pdf$); })
        ).subscribe((data) => {
            this.pdfAvailable = data !== null;
            this.loader.toggleLoader(false);
            this._isLoading$.next(false);
            this.showRejectButton = this.coreReviewModel.currentLevel.mode === 'chief'; 
            if (this.coreReviewModel.currentLevel.mode === 'initiator') {
                this.approveText = 'Confirm'
            }
            else if (this.coreReviewModel.currentLevel.mode !== 'initiator' && this.coreReviewModel.currentLevel.levelNumber === '1') {
                this.approveText = 'Send to Next Level';
            }
            else {
                this.approveText = 'Approve';
            }               

        }, (error) => {
            console.error(error);
            this.showError = true;
            this.loader.toggleLoader(false);
        });       
    }

    download(): void {
        const blob = new Blob([this.pdfData], { type: "application/pdf" });
        const fileName = `order-preview.pdf`;
		const url = URL.createObjectURL(blob);
		const link = this.downloadLink.nativeElement;
		link.href = url;
		link.download = fileName;
		link.click();
    }

    nextPage(): void {
        if (this.currentPage >= this.totalPages) return;
        this.currentPage++;
    }

/*onLoadComplete(pdf: PDFDocumentProxy): void {*/
	onLoadComplete(pdf: any): void {
        this.totalPages = pdf.numPages;
    }

    previousPage(): void {
        if (this.currentPage <= 1) return;
        this.currentPage--;
    }

    rejectCO(): void {
        this.loader.toggleLoader(true);
        this.coreReviewModel.currentReview.reviewStatus = chiefsOrderReviewStatus.Rejected;
        const res$ = this.chiefsOrderService.rejectco(this.coreReviewModel).pipe(finalize(() => {
            this.subscription.add(res$);
        })).subscribe(x => {
            var gp = this.coreReviewModel.currentLevel.assignToGroup;
            this.loader.toggleLoader(false);
            this.confirmRejectionDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.confirmRejectionDialog);
        }, error => console.log(error));
    }

    approveCO(): void {

        //If they're not picking a group move on, 
        if (!this.displayGroupAssignment ||
            (this.displayGroupAssignment && (this.selectedGroup.id != "0" || (this.coreReviewModel.priorLevel.canSelectAssignToGroup && this.coreReviewModel.priorLevel.levelId != this.coreReviewModel.currentLevel.levelId)))) {
            this.loader.toggleLoader(true);
            let needSignature = this.coreReviewModel.currentLevel.mode === 'chief' ? true : false;

            //Only bother saving the selected group if the next level requires a group selection
            if (this.coreReviewModel.nextLevelOfReviewRequiresGroupSelection)
                this.coreReviewModel.userSelectedGroup = this.selectedGroup;

            this.coreReviewModel.currentReview.reviewStatus = chiefsOrderReviewStatus.Approved;

            const res$ = this.chiefsOrderService.approveco(this.coreReviewModel).pipe(finalize(() => {
                this.subscription.add(res$)
                this.loader.toggleLoader(false);
            })).subscribe(x => {
                if (needSignature) {
                    let flowid = this.coInstanceId;
                    this.router.navigate(['/admin/chief-orders/co-signature', flowid]);
                }
                else {
                    this.confirmSubmittalDialog.message = `The order was submitted to ${x} group for review.`;
                    this.confirmSubmittalDialog.toggleDialog(true);
                    this.dialogService.updateDialog(this.confirmSubmittalDialog);
                }

            }, error => console.log(error));
        }
        else {
            this.selectAReviewGroupReminderDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.selectAReviewGroupReminderDialog);
        }
    }

    addReviewNote(): void {
        const note = {
            documentType: "Note",
            isDeleted: false,
            createdDate: undefined,
            createdById: this._authService.User.id,
            createdBy: this._authService.User.displayName,
            type: (this.isInternalVal) ? NoteType.Internal : NoteType.General,
            text: this.notesText
        } as Note;
        this.coreReviewModel.notes.push(note);
        this.saveNotes();
    }

    goEditLetter(): void {
        this.confirmTextEditDialog.toggleDialog(false);
        this.dialogService.updateDialog(this.confirmTextEditDialog);
        this.setCurrentView('edit-letter');
    }

    goToReturnView(): void {
        if (!this.displayGroupAssignment || (this.displayGroupAssignment && this.selectedGroup.id != "0")) {
            this.setCurrentView('return');
        }
        else {
            this.selectAReviewGroupReminderDialog.toggleDialog(true);
            this.dialogService.updateDialog(this.selectAReviewGroupReminderDialog);
        }

    }

    goToCancelView(): void {
        this.setCurrentView('cancel');
    }

    savedFiles($event: IUploadFile) {
        var newFile = $event;
        this.filesToShow.push(newFile);
    }

    saveNotes(): void {
        this.loader.toggleLoader(true);
        const res$ = this.chiefsOrderService.savereviewnote(this.coreReviewModel).pipe(finalize(() => {
            this.notesText = '';
            this.isInternalVal = false;
        })).subscribe(x => {
            console.log(x);
            this.coreReviewModel = x;
            this.sidePanelService.updateSectionData("ReviewNotesCommon", this.coreReviewModel.notes);
            this.loadData(this.coInstanceId);
            this.loader.toggleLoader(false);
        }, (error) => {
            console.log(error);
            this.loader.toggleLoader(false);
        });
        this.subscription.add(res$)
    }

    public hasFileListing(): boolean {
        return this.filesToShow.length > 0 ? true : false;
    }
    public allowFileDeletion(file: IUploadFile): boolean {
        return (this._authService.User.id === file.uploadedByUserId || this._authService.User.organizationId === file.uploadedByOrganizationId);
    }

    deleteFile($event: IUploadFile) {
        this.fileToDelete = $event;
        this.confirmFileDeleteDialog.message = `Are you sure you want to delete this file?`;
        this.confirmFileDeleteDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.confirmFileDeleteDialog);
    }

    downloadFile($event: IUploadFile) {
        var file = $event;
        const download$ = this.docMgmtSrvc.downloadFile(file.blobUri).pipe(
            tap((data) => {
                const link = this.downloadLink.nativeElement;
                link.href = data;
                link.click();
            }),
            finalize(() => {
                this.subscription.add(download$);
            })
        ).subscribe(() => { });
    }

    noteReplied(notes: Note[]): void {
        this.coreReviewModel.notes = notes;
        this.saveNotes();
    }

    public setCurrentView(viewName: string): void {
        this.location.replaceState('/admin/chief-orders/co-' + viewName + '/' + this.coInstanceId);
        this.currentView = viewName;
    }

    public setCoreReviewModel(reviewModel: coReviewViewModel): void {
        this.coreReviewModel = reviewModel;
    }

    public setCoreReviewModelLetter(reviewModel: coReviewViewModel): void {
        this.coInstanceId = this.coreReviewModel.instanceId;
        this.loader.toggleLoader(true);
        this.loadData(this.coInstanceId);
    }

    public onFileDeleteConfirm() {
        this.loader.toggleLoader(true);

        var abandon$ = this.docMgmtSrvc.abandon(this.fileToDelete).pipe(
            tap((results) => {
                const index = this.filesToShow.findIndex(x => x.blobUri === this.fileToDelete.blobUri);
                if (index !== -1) {
                    this.filesToShow.splice(index, 1);
                    //Now make sure the file got removed from the upload-view-files component too
                    this._uploadViewFilesElement.removeFile(this.fileToDelete);
                }
                else {
                    const index = this.supplementalFilesToShow.findIndex(x => x.blobUri === this.fileToDelete.blobUri);
                    if (index !== -1) {
                        this.supplementalFilesToShow.splice(index, 1);
                        this._uploadViewSupplementalFilesElement.removeFile(this.fileToDelete);
                    }
                }
            }),
            mergeMap(() => {

                return this.chiefsOrderService.deleteFilesFromContext(this.fileToDelete, this.coInstanceId).pipe(
                    tap((groups) => {
                        let contextFileIndex = this.coreReviewModel.files.findIndex(x => x.blobUri === this.fileToDelete.blobUri);
                        if (contextFileIndex !== -1) {
                            this.coreReviewModel.files.splice(contextFileIndex, 1);
                        }
                        else {
                            const contextFileIndex = this.coreReviewModel.postIssueFiles.findIndex(x => x.blobUri === this.fileToDelete.blobUri);
                            if (contextFileIndex !== -1)
                                this.coreReviewModel.postIssueFiles.splice(contextFileIndex, 1);
                        }
                        console.log('file was deleted: ', this.fileToDelete.fileName);
                    })
                );
            }),
            finalize(() => { this.subscription.add(abandon$); }))
            .subscribe(() => {

                this.loader.toggleLoader(false);

            }, (error) => { console.error(error); this.loader.toggleLoader(false); });
    }

    savedSupplementalFiles($event: IUploadFile) {
        var newFile = $event;
        this.supplementalFilesToShow.push(newFile);
    }

    public hasSupplementalFileListing(): boolean {
        return this.supplementalFilesToShow.length > 0 ? true : false;
    }

    public onSubmittalDialogConfirm() {
        this.router.navigate(['/home']);
    }

    public onRejectionDialogConfirm() {
        this.router.navigate(["/dashboard/view/ricsDashboard"]);
    }

    onSelectAReviewGroupReminderDialogConfirm() {
        this.selectAReviewGroupReminderDialog.toggleDialog(false);
        this.dialogService.updateDialog(this.selectAReviewGroupReminderDialog);
    }

    toggleConfirmEditTextDialogue() {
        this.confirmTextEditDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.confirmTextEditDialog);
    }
}
